import React from 'react';
import { AddOnViewProps } from './type';
import { useSessionContext } from '../../../contexts/sessionProvider/SessionProvider';
import { AddOn } from './AddOn';

export const AddOnsView: React.FC<AddOnViewProps> =
  ({
    productData
  }) => {
    const { addonIds } = useSessionContext();
    return (
      <>
        { addonIds?.map(addOnId => (
          <AddOn
            key={addOnId}
            addOnId={addOnId}
            productData={productData.find(it => it.items[0]?.productId === addOnId)!}
          />
        )) }
      </>
    );
  }